const mapStateToProps = (state) => ({
  // data: state.constanciaCandidatoEleccionPopular.data,
  // data: "[]",
  // currentUser: state.security.currentUser,
  //dataUsuarioPorAsociarVacia: state.asociarUsuarios.dataUsuarioPorAsociarVacia
});

export default mapStateToProps;
